'use client';

import React from 'react';
import { BosIconsPath, BosIconsViewBox, IconType } from './icons';
import { cn, TIconProps } from 'types';
import { BosFullIcon } from './BosFullIcon';

export const Icon = ({
  className = '',
  fill = 'var(--color-black)',
  icon,
  onClick,
  width = 32,
  height = 32,
  viewBox,
}: TIconProps) => {
  if (icon === IconType.BOS) {
    return <BosLogoIconWithGradient width={width} height={height} />;
  }
  if (icon === IconType.BOSFull) {
    return <BosFullIcon width={width} height={height} />;
  }

  const clickableIcon = typeof onClick === 'function';
  const DynamicTag = clickableIcon ? 'div' : React.Fragment;

  return (
    <DynamicTag
      {...(clickableIcon && {
        className: className,
        onClick: () => (clickableIcon ? onClick() : null),
        style: {
          height: `${height}px` || '2rem',
          width: `${width}px` || '2rem',
        },
      })}
    >
      <svg
        className={cn('shrink-0 align-middle', clickableIcon ? 'w-full h-full' : className)}
        viewBox={viewBox || BosIconsViewBox[icon] || '0 0 24 24'}
        width={width || 32}
        height={height || 32}
      >
        <path clipRule={'evenodd'} d={BosIconsPath[icon]} fill={fill} fillRule="evenodd" />
      </svg>
    </DynamicTag>
  );
};
export { IconType };

const BosLogoIconWithGradient = ({ height = 24, width = 24, ...props }: Partial<TIconProps>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M18.5537 2.02151C19.8393 3.7337 20.5502 5.78524 20.6561 7.88305C20.7619 10.1351 20.1721 12.4335 18.8109 14.4233C17.7673 15.935 16.4212 17.0764 14.8936 17.8322C17.979 16.2589 19.31 12.4335 17.8278 9.22504C16.3909 6.06289 12.7761 4.62836 9.64532 5.92406C9.6302 5.92406 9.61508 5.93949 9.59995 5.93949C9.55458 5.95491 9.5092 5.97034 9.47896 6.00119C9.43358 6.01661 9.38821 6.04746 9.32771 6.06289C9.26721 6.09374 9.22184 6.12459 9.16134 6.14002C7.64887 6.89585 6.28766 8.0373 5.24405 9.54896C3.88284 11.5388 3.29297 13.8371 3.39885 16.0892C3.50472 18.187 4.21558 20.2386 5.50117 21.9508C3.77696 20.7784 2.325 19.1125 1.37214 17.0456C0.434415 14.9786 0.116795 12.7728 0.343665 10.6596C0.782279 6.63362 3.20223 2.94702 7.05901 1.11143C10.9158 -0.708732 15.2566 -0.215128 18.5537 2.02151Z"
      fill="url(#paint0_linear_16335_48685)"
    />
    <path
      d="M6.21146 14.7626C7.66342 17.9247 11.2782 19.3593 14.409 18.0636C14.4241 18.0636 14.4393 18.0481 14.4544 18.0481C14.4998 18.0327 14.5451 18.0173 14.5754 17.9864C14.6208 17.971 14.6813 17.9402 14.7266 17.9247C14.7871 17.8939 14.8325 17.863 14.893 17.8476C16.4055 17.0918 17.7667 15.9503 18.8103 14.4387C20.1715 12.4488 20.7614 10.1505 20.6555 7.89841C20.5496 5.80059 19.8388 3.74905 18.5532 2.03687C20.2774 3.20917 21.7294 4.87508 22.6671 6.94205C23.6048 9.00901 23.9224 11.2148 23.6956 13.328C23.2569 17.354 20.837 21.0406 16.9802 22.8762C13.1234 24.7118 8.78265 24.2182 5.48547 21.9815C4.19987 20.2693 3.48902 18.2178 3.38314 16.12C3.27727 13.8679 3.86713 11.5696 5.22835 9.57974C6.27196 8.03723 7.63317 6.89577 9.14564 6.13994C6.06021 7.72873 4.74436 11.5387 6.21146 14.7626Z"
      fill="url(#paint1_linear_16335_48685)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_16335_48685"
        x1="6.52122"
        y1="9.76406"
        x2="19.7656"
        y2="14.4909"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FCFCFC" />
        <stop offset="0.4003" stop-color="#FCFCFC" />
        <stop offset="1" stop-color="#FCFCFC" stop-opacity="0.3" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_16335_48685"
        x1="17.1851"
        y1="14.0865"
        x2="4.272"
        y2="9.47784"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FCFCFC" />
        <stop offset="0.4003" stop-color="#FCFCFC" />
        <stop offset="1" stop-color="#FCFCFC" stop-opacity="0.3" />
      </linearGradient>
    </defs>
  </svg>
);
